import axios from './axiosFile';
import Cookies from 'js-cookie';
const bearerToken = Cookies.get('bearerToken');

export default {
  uploadFile: async (id, type, file) => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const { data } = await axios.post(`/${type}/${id}`, file, {
      config
    });
    return data;
  },

  deleteFile: async (id, type, fileName, projectId) => {
    const params = { fileName };
    if (projectId) params['projectId'] = projectId;

    const { data } = await axios.delete(`/${type}/${id}`, {
      data: params,
      config: {
        headers: {
          authorization: bearerToken
        }
      }
    });
    return data;
  },

  getImage: async src => {
    const res = await axios.get(src);
    return res;
  }
};
